import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import {
  getBookSnappTripAdminService,
  getBookVoucherSnappTripAdminService,
  getBooksSnappTripAdminService,
} from "../../../services/adminServices";

export const snappTripBooksAdminContext = createContext({
  books: [],
  setBooks: () => {},
  book: {},
  setBook: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  handleGetBooks: () => {},
  handleGetBook: () => {},
  handleGetBookVoucher: () => {},
});

const SnappTripBooksAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [books, setBooks] = useState([]);
  const [book, setBook] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(50);

  // Get Books
  const handleGetBooks = async (event) => {
    event?.preventDefault();

    const objData = {
      page: pageNumber,
      page_size: itemsCount,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBooksSnappTripAdminService(objData);
      if (status === 200) {
        const result = data.result;

        setBooks(result.data);
        setPageCount(Math.ceil(result?.meta?.total / result?.meta?.page_size));
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Get Book
  const handleGetBook = async (reservation_code) => {
    const objData = { reservation_code };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBookSnappTripAdminService(objData);
      if (status === 200) {
        setBook(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Get Book Voucher
  const handleGetBookVoucher = async (reservation_code, lang = "fa") => {
    const objData = { reservation_code, lang };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBookVoucherSnappTripAdminService(
        objData
      );
      if (status === 200) {
        window.open(data.result?.url);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <snappTripBooksAdminContext.Provider
      value={{
        books,
        setBooks,
        book,
        setBook,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetBooks,
        handleGetBook,
        handleGetBookVoucher,
      }}
    >
      {children}
    </snappTripBooksAdminContext.Provider>
  );
};

export default SnappTripBooksAdminContext;
